// extracted by mini-css-extract-plugin
module.exports = {"grey_text":"a2c79c7e7d--grey_text--wKMNE","villages_link":"a2c79c7e7d--villages_link--pBQht","villages_count":"a2c79c7e7d--villages_count--noHvk"};